<template>
  <div class="transport-service-map-toolbar">
    <div class="top-controls">
      <div class="top-controls__row">
        <div v-if="!hideColorConfig" class="top-controls__color-panel">
          <button type="button" class="map-tool-color-btn" @click="colorDialogVisible = true">
            轨迹颜色
          </button>
        </div>
        <div class="top-controls__map-tools">
        <div
          v-if="rangingOnly"
          class="map-tool-item"
          @click="$emit('action', { type: 'ranging' })"
        >
          <img src="@/assets/ceju.png" alt="" class="control-btn-icon" />
          <el-button type="text" class="control-btn">测距</el-button>
        </div>
        <div
          v-else
          class="map-tool-item map-tool-dropdown"
          :class="{ 'is-tools-open': toolsMenuOpen }"
          @click.stop="$emit('action', { type: 'toggleToolsMenu' })"
        >
          <img src="@/assets/setting.png" alt="" class="control-btn-icon" />
          <el-button type="text" class="control-btn" >工具</el-button>
          <div v-show="toolsMenuOpen" class="tools-pop" @click.stop>
            <div class="tools-pop-grid">
              <div
                class="tools-pop-cell tools-pop-cell--act"
                @click="$emit('action', { type: 'toggleHideParking' })"
              >
                <img src="@/assets/tingchedianBtn.png" alt="" class="tools-pop-ico" />{{
                  hideParkingMarkers ? '显示停车点' : '隐藏停车点'
                }}
              </div>
              <div
                class="tools-pop-cell tools-pop-cell--act"
                @click="$emit('action', { type: 'toggleHideEndpoints' })"
              >
                <img src="@/assets/qizhong.png" alt="" class="tools-pop-ico" />{{
                  hideEndpointMarkers ? '显示起终点' : '隐藏起终点'
                }}
              </div>
              <div
                class="tools-pop-cell tools-pop-cell--act"
                @click="$emit('action', { type: 'toggleReportPoints' })"
              >
                <img src="@/assets/weizhiBtn.png" alt="" class="tools-pop-ico" />{{
                  reportPointsOnly ? '恢复轨迹' : '上报位置'
                }}
              </div>
              <div class="tools-pop-cell tools-pop-cell--act" @click="$emit('action', { type: 'ranging' })">
                <img src="@/assets/ceju.png" alt="" class="tools-pop-ico" />测量距离
              </div>
            </div>
          </div>
        </div>
        <div class="map-tool-item" @click="$emit('action', { type: 'toggleSatellite' })">
          <img src="@/assets/weixing.png" alt="" class="control-btn-icon" />
          <el-button type="text" class="control-btn" >{{
            showSatellite ? '普通' : '卫星'
          }}</el-button>
        </div>
        <div v-if="showGlobal" class="map-tool-item" @click="$emit('action', { type: 'openGlobalMap' })">
          <img src="@/assets/quanju.png" alt="" class="control-btn-icon" />
          <el-button type="text" class="control-btn">全局</el-button>
        </div>
        <div class="map-tool-item" @click="$emit('action', { type: 'toggleFullscreen' })">
          <img src="@/assets/quanping.png" alt="" class="control-btn-icon" />
          <el-button type="text" class="control-btn" >全屏</el-button>
        </div>
      </div>
      </div>
      <div class="zoom-controls">
        <i
          class="el-icon-plus zoom-controls__btn"
          title="放大"
          @click="$emit('action', { type: 'zoomIn' })"
        />
        <i
          class="el-icon-minus zoom-controls__btn"
          title="缩小"
          @click="$emit('action', { type: 'zoomOut' })"
        />
      </div>
    </div>
    <TrajectoryColorConfigDialog
      v-if="!hideColorConfig"
      :visible.sync="colorDialogVisible"
      @saved="onColorConfigSaved"
    />
  </div>
</template>

<script>
import TrajectoryColorConfigDialog from '@/components/TrajectoryColorConfigDialog.vue'

export default {
  name: 'TransportServiceMapToolbar',
  components: { TrajectoryColorConfigDialog },
  props: {
    toolsMenuOpen: {
      type: Boolean,
      default: false
    },
    showSatellite: {
      type: Boolean,
      default: false
    },
    hideParkingMarkers: {
      type: Boolean,
      default: false
    },
    hideEndpointMarkers: {
      type: Boolean,
      default: false
    },
    reportPointsOnly: {
      type: Boolean,
      default: false
    },
    /** 货物中转等场景：隐藏轨迹颜色配置 */
    hideColorConfig: {
      type: Boolean,
      default: false
    },
    showGlobal: {
      type: Boolean,
      default: false
    },
    /** 运单地图等场景：工具改为测距直达，无下拉菜单 */
    rangingOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      colorDialogVisible: false
    }
  },
  methods: {
    onColorConfigSaved(config) {
      this.$emit('action', { type: 'colorConfig', value: config })
    }
  }
}
</script>

<style>
/* 与 transportService/index.vue 右侧地图工具条一致，供主站与插件页共用 */
.transport-service-map-toolbar,
.transport-service-map-toolbar .top-controls,
.transport-service-map-toolbar .top-controls__row {
  /* 外层不拦截：工具条与缩放之间的空白可穿透到地图拖移/点击 */
  pointer-events: none;
}

.transport-service-map-toolbar .top-controls {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.625rem;
}

.transport-service-map-toolbar .top-controls__row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0.625rem;
}

.transport-service-map-toolbar .top-controls__color-panel,
.transport-service-map-toolbar .top-controls__map-tools,
.transport-service-map-toolbar .zoom-controls {
  pointer-events: auto;
}

.transport-service-map-toolbar .top-controls__color-panel,
.transport-service-map-toolbar .top-controls__map-tools {
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  gap: 0.5rem;
  border-radius: 0.3125rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.12);
  padding: 0.6rem 0.75rem !important;
}

.transport-service-map-toolbar .top-controls__color-panel {
  justify-content: center;
}

.transport-service-map-toolbar .map-tool-color-btn {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: #303133;
  cursor: pointer;
  white-space: nowrap;
}

.transport-service-map-toolbar .map-tool-color-btn:hover {
  color: var(--layout-primary, #087dff);
}

.transport-service-map-toolbar .map-tool-item {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
}

.transport-service-map-toolbar .map-tool-item:hover {
  background: rgba(22, 119, 255, 0.06);
}

.transport-service-map-toolbar .map-tool-dropdown {
  position: relative;
}

.transport-service-map-toolbar .map-tool-dropdown.is-tools-open {
  background: rgba(22, 119, 255, 0.08);
  border-radius: 0.25rem;
}

.transport-service-map-toolbar .tools-pop {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 30;
  min-width: 220px;
  padding: 10px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.14);
}

.transport-service-map-toolbar .tools-pop-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.transport-service-map-toolbar .tools-pop-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 6px;
  font-size: 12px;
  line-height: 1.25;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.transport-service-map-toolbar .tools-pop-cell--act {
  cursor: pointer;
  color: #303133;
}

.transport-service-map-toolbar .tools-pop-cell--act:hover {
  background: rgba(22, 119, 255, 0.08);
  border-color: #c6e2ff;
}

.transport-service-map-toolbar .tools-pop-cell--act i {
  font-size: 14px;
  color: #7c8196;
}

.transport-service-map-toolbar .tools-pop-ico {
  width: 14px;
  height: 14px;
}

.transport-service-map-toolbar .control-btn-icon {
  width: 1.125rem;
  height: 1.125rem;
  display: block;
}

.transport-service-map-toolbar .control-btn {
  font-size: 0.875rem;
  border: none;
  background: transparent;
  padding: 0;
  line-height: 1.125rem;
  color: #303133;
}

.transport-service-map-toolbar .zoom-controls {
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 0.3125rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.12);
  padding: 0.6rem 0.75rem !important;
  gap: 0.75rem;
}

.transport-service-map-toolbar .zoom-controls__btn {
  font-size: 1.25rem;
  font-weight: 700;
  color: #7c8196;
  cursor: pointer;
  line-height: 1;
  user-select: none;
}

.transport-service-map-toolbar .zoom-controls__btn:hover {
  color: var(--layout-primary, #087dff);
}

@media (max-width: 768px) {
  .transport-service-map-toolbar .top-controls {
    flex-direction: column;
    align-items: flex-end;
    gap: 0.375rem;
  }

  .transport-service-map-toolbar .top-controls__row {
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.375rem;
  }

  .transport-service-map-toolbar .top-controls__color-panel,
  .transport-service-map-toolbar .top-controls__map-tools {
    flex-wrap: wrap;
    gap: 0.25rem;
    padding: 0.375rem 0.5rem !important;
  }

  .transport-service-map-toolbar .map-tool-item .control-btn {
    display: none;
  }

  .transport-service-map-toolbar .zoom-controls {
    padding: 0.375rem 0.5rem !important;
  }
}
</style>
